// extracted by mini-css-extract-plugin
export var modal = "_ff-0";